// import { NavLink } from "react-router-dom";

import { useCallback, useEffect } from "react";
// import { useProfile } from "../context/ProfileContext";
import { useDispatch } from "react-redux";
import { setProfile, setRoute } from "../store";

function Home() {
  // const { setProfile } = useProfile();
  const dispatch = useDispatch();
  const handleCredentialResponse = useCallback(
    (response) => {
      // console.log("Encoded JWT ID token:", response);
      // Send the token to your backend for verification
      // const token = response.credential;
      fetch(`${process.env.REACT_APP_API_URL}/api/protected`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          // Pass the token as a Bearer token in the Authorization header
          Authorization: `Bearer ${response.credential}`,
        },
      })
        .then((res) => res.json())
        .then((data) => {
          console.log(data);
          localStorage.setItem("authToken", data.user.jwt);
          dispatch(setProfile(data.user));
          
          if (data.route) {
            dispatch(setRoute(data.route));
          } else {
            const crudJson = require('../crud.json');
            const cat = [ ...crudJson.category ];
            crudJson.route = { category: cat };
            dispatch(setRoute(crudJson));
          }
        })
        .catch((error) => console.error("Error:", error));
    },
    [dispatch]
  );

  useEffect(() => {
    // Ensure the google object is available
    if (window.google) {
      window.google.accounts.id.initialize({
        client_id: process.env.REACT_APP_GOOGLE_CLIENT_ID,
        callback: handleCredentialResponse,
      });
      window.google.accounts.id.renderButton(
        document.getElementById("googleSignInDiv"),
        { theme: "outline", size: "small" }
      );
    }
  }, [handleCredentialResponse]);

  return (
    <div className="page-container">
      <aside>
        <ul></ul>
      </aside>
      <main>
        {/* Renders the selected left nav child component */}
        <h1>Please Login to Proceed</h1>
        <div className="user-info">
          <div id="googleSignInDiv"></div>
        </div>
      </main>
    </div>
  );
}

export default Home;
